import VueI18n from "vue-i18n";
import zh from "@/locales/zh-CN";
import en from "@/locales/en-US";
import ja from "@/locales/ja-JP";
import { initLang, getLang } from "./lang";

const messages = {
  "zh-CN": zh,
  "ja-JP": ja,
  "en-US": en,
};

let langObj = null;
const LocaleService = {
  install(vue) {
    vue.use(VueI18n);
  },
  getLocale: async () => {
    const langType = await initLang();
    langObj = new VueI18n({
      locale: langType,
      messages,
    });
    return langObj;
  },
};

function setLang(lang) {
  if (langObj && Object.keys(messages).indexOf(lang) >= 0) {
    langObj.locale = lang;
  }
}

export default LocaleService;
export { getLang, setLang };
